var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container p-8"},[(!_vm.organizer)?_c('loading-indicator'):_c('organizer-dashboard-view',{attrs:{"organizer":_vm.organizer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }